import { useEffect, useRef, useState } from 'react'

import { Button, Flex, Text } from '@/shared/ui'

import { SendIcon } from '../../assets/send'

import cl from './messege-input.module.scss'

interface MessegeInputProps {
	onSumbmit: (value: string) => void
	onCreateChat: () => void
	isDisabled: boolean
	isActive?: boolean
	startText: string
	onFocus?: () => void
	isDesktop?: boolean
}

const ALLOWED_TEXT_LENGTH = 5

export const MessegeInput = ({
	onSumbmit,
	onCreateChat,
	isDisabled,
	isActive,
	startText = '',
	onFocus: onFocusProp,
	isDesktop
}: MessegeInputProps) => {
	const [inputValue, setInputValue] = useState(startText)
	const textareaRef = useRef<HTMLTextAreaElement>(null)
	const wasDisabledRef = useRef(isDisabled)

	const allowedTextLength = !!inputValue ? inputValue?.trim()?.length >= ALLOWED_TEXT_LENGTH : false

	const onSumbmitHandler = () => {
		if (isDisabled || !allowedTextLength) return

		onSumbmit(inputValue)
		setInputValue('')
	}

	const handleKeyPress = (e: React.KeyboardEvent) => {
		if (e.key === 'Enter' && !e.shiftKey) {
			e.preventDefault()
			onSumbmitHandler()
		}
	}

	const onFocus = () => {
		onFocusProp?.()
	}

	useEffect(() => {
		setInputValue(startText)
	}, [startText])

	// На десктопе при переходе состояния isDisabled из true в false ставим фокус на textarea
	useEffect(() => {
		if (isDesktop && wasDisabledRef.current && !isDisabled) {
			textareaRef.current?.focus()
		}
		wasDisabledRef.current = isDisabled
	}, [isDisabled, isDesktop])

	if (!isActive) {
		return (
			<div className={cl.inputArea}>
				<Flex gap={10} className={cl.not_active_content} column alignCenter justifyCenter>
					<Text size="4" className={cl.not_active_text}>
						Чат больше не активен
					</Text>
					<Button onClick={onCreateChat}>Создать новый чат</Button>
				</Flex>
			</div>
		)
	}

	return (
		<div className={cl.inputArea}>
			<textarea
				ref={textareaRef}
				value={inputValue}
				onChange={e => setInputValue(e.target.value)}
				onKeyPress={handleKeyPress}
				onFocus={onFocus}
				placeholder="Введите сообщение..."
				rows={2}
				cols={2}
				className={cl.textarea}
				disabled={isDisabled}
				maxLength={100}
			/>

			<Button onClick={onSumbmitHandler} disabled={isDisabled || !allowedTextLength} className={cl.button}>
				<SendIcon />
			</Button>
		</div>
	)
}
